import { DocumentsFilters } from '@/services/documents-service/documents-service.types';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';
import { OrderBy } from '../use-sort-and-pagination/use-sort-and-pagination.types';
import { getDocuments } from '@/services/documents-service/documents-service';

interface DocumentsFiltersProps {
  filtersParams?: DocumentsFilters;
  paginationParams: {
    sort_by?: string;
    order_by: OrderBy;
    page: number;
    items_per_page: number;
  };
}

export const useDocuments = ({ filtersParams, paginationParams }: DocumentsFiltersProps) => {
  const { data: documentsData, isPending } = useQuery({
    queryKey: ReactQueryKeys.DOCUMENTS({ ...filtersParams, ...paginationParams }),
    queryFn: () => getDocuments({ ...filtersParams, ...paginationParams }),
  });

  return { documentsData, isPending };
};
